import tokenManagementTab from './tokenManagementTab';
import tokensTab from './tokensTab';

export default [
  tokenManagementTab,
  tokensTab,
];
